export default __webpack_public_path__ + "5b27742692c93fba726aa11172ca7795.png";